import { useState } from "react";
import { useShovellerSignupContext } from "../../../../context/shovllerSignupFormContext";
import { Label } from "../../../ui/label";
import { Checkbox } from "../../../ui/checkbox";
import { StepFooterNav } from "../../shared/NavigationFooter";
import { FaCar, FaWalking, FaClock, FaBullhorn } from "react-icons/fa";

export function Step6({ nextStep, preStep, currentStep, totalSteps }) {
  const { formData, setFormData } = useShovellerSignupContext();
  const [errors, setErrors] = useState({});

  const handleTransportationChange = (method, checked) => {
    if (checked) {
      setFormData((prev) => ({ ...prev, transportation: [method] }));
    } else {
      setFormData((prev) => ({ ...prev, transportation: [] }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    let tempErrors = {};

    if (!formData.transportation || formData.transportation.length === 0) {
      tempErrors.transportation = "Please select a mode of transport.";
    }
    if (!formData.maxTravelTime) {
      tempErrors.maxTravelTime = "Please select a travel time.";
    }
    if (!formData.hearAboutUs) {
      tempErrors.hearAboutUs = "Please tell us how you heard about us.";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleNext = () => {
    if (validate()) {
      nextStep();
    }
  };

  const selectClass =
    "flex h-10 w-full rounded-md border border-gray-200 bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50";

  return (
    <div className="flex flex-col px-6 py-10 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold text-gray-900">Additional Details</h2>
      <p className="text-gray-600 mb-8">
        Help us match you with the right jobs.
      </p>

      <div className="space-y-8">
        {/* Transportation  */}
        <div>
          <Label className="flex items-center gap-2 mb-3 text-base font-semibold">
            How do you commute? <span className="text-red-500">*</span>
          </Label>
          <div className="flex gap-4 sm:gap-6 flex-col sm:flex-row">
            <div
              className={`flex items-center space-x-3 border p-3 rounded-lg w-full cursor-pointer transition-colors ${formData.transportation?.includes("Drive") ? "border-black bg-gray-50" : "hover:bg-gray-50"}`}
              onClick={() =>
                handleTransportationChange(
                  "Drive",
                  !formData.transportation?.includes("Drive"),
                )
              }
            >
              <Checkbox
                id="drive"
                checked={formData.transportation?.includes("Drive")}
                onCheckedChange={(checked) =>
                  handleTransportationChange("Drive", checked)
                }
              />
              <Label
                htmlFor="drive"
                className="flex items-center gap-2 cursor-pointer font-normal w-full pointer-events-none"
              >
                <FaCar className="text-gray-500" /> Drive
              </Label>
            </div>

            <div
              className={`flex items-center space-x-3 border p-3 rounded-lg w-full cursor-pointer transition-colors ${formData.transportation?.includes("Walk") ? "border-black bg-gray-50" : "hover:bg-gray-50"}`}
              onClick={() =>
                handleTransportationChange(
                  "Walk",
                  !formData.transportation?.includes("Walk"),
                )
              }
            >
              <Checkbox
                id="walk"
                checked={formData.transportation?.includes("Walk")}
                onCheckedChange={(checked) =>
                  handleTransportationChange("Walk", checked)
                }
              />
              <Label
                htmlFor="walk"
                className="flex items-center gap-2 cursor-pointer font-normal w-full pointer-events-none"
              >
                <FaWalking className="text-gray-500" /> Walk
              </Label>
            </div>
          </div>
          {errors.transportation && (
            <p className="text-xs text-red-500 mt-1">{errors.transportation}</p>
          )}
        </div>

        {/* Travel Time */}
        <div>
          <Label className="flex items-center gap-2 mb-2 text-base font-semibold">
            <FaClock className="w-4 h-4 text-gray-500" /> How long are you
            willing to travel? <span className="text-red-500">*</span>
          </Label>
          <select
            name="maxTravelTime"
            value={formData.maxTravelTime || ""}
            onChange={handleChange}
            className={selectClass}
          >
            <option value="" disabled>
              Select duration
            </option>
            <option value="10 min">10 min</option>
            <option value="20 min">20 min</option>
            <option value="30 min">30 min</option>
            <option value="45 min">45 min</option>
            <option value="1 hr">1 hr</option>
          </select>
          {errors.maxTravelTime && (
            <p className="text-xs text-red-500 mt-1">{errors.maxTravelTime}</p>
          )}
        </div>

        <div>
          <Label className="flex items-center gap-2 mb-2 text-base font-semibold">
            <FaBullhorn className="w-4 h-4 text-gray-500" /> How'd you hear
            about us? <span className="text-red-500">*</span>
          </Label>
          <select
            name="hearAboutUs"
            value={formData.hearAboutUs || ""}
            onChange={handleChange}
            className={selectClass}
          >
            <option value="" disabled>
              Select source
            </option>
            <option value="YouTube">YouTube</option>
            <option value="Instagram">Instagram</option>
            <option value="Facebook">Facebook</option>
            <option value="RedNote">RedNote</option>
            <option value="LinkedIn">LinkedIn</option>
            <option value="Friend Referral">Friend Referral</option>
            <option value="Other">Other</option>
          </select>
          {errors.hearAboutUs && (
            <p className="text-xs text-red-500 mt-1">{errors.hearAboutUs}</p>
          )}
        </div>
      </div>

      <StepFooterNav
        currentStep={currentStep}
        totalSteps={totalSteps}
        onBack={preStep}
        onNext={handleNext}
        nextDisabled={false}
      />
    </div>
  );
}
